var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyBro({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155.61,
    height: 152.604,
    viewBox: "0 0 155.61 152.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Currency-bro",
    transform: "translate(0 0.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-21",
    transform: "translate(0 3.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3950",
    "data-name": "Path 3950",
    d: "M162.777,104.29c-4.865,12.741-14.8,26.532-28.778,30.617-21.136,6.172-23.646,22.829-61.48,21.285a77.826,77.826,0,0,1-16.367-2.346,65.2,65.2,0,0,1-7.685-2.5c-22.1-8.76-33.633-28.038-34.588-48.208C12.617,76.6,31.534,63.957,43.829,56.554s27.114-36.081,64.317-34.863a75.516,75.516,0,0,1,16.817,2.4c12.52,3.315,25.245,10.647,32.642,21.366q.832,1.212,1.592,2.469C169.1,64.361,169.405,86.919,162.777,104.29Z",
    transform: "translate(-13.818 -21.653)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3951",
    "data-name": "Path 3951",
    d: "M162.777,104.29c-4.865,12.741-14.8,26.532-28.778,30.617-21.136,6.172-23.646,22.829-61.48,21.285a77.826,77.826,0,0,1-16.367-2.346,65.2,65.2,0,0,1-7.685-2.5c-22.1-8.76-33.633-28.038-34.588-48.208C12.617,76.6,31.534,63.957,43.829,56.554s27.114-36.081,64.317-34.863a75.516,75.516,0,0,1,16.817,2.4c12.52,3.315,25.245,10.647,32.642,21.366q.832,1.212,1.592,2.469C169.1,64.361,169.405,86.919,162.777,104.29Z",
    transform: "translate(-13.818 -21.653)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-21",
    transform: "translate(26.756 24.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3952",
    "data-name": "Path 3952",
    d: "M349.519,217.893s.5-4.987-1.5-7.233-4.987.5-4.24,3.491S349.519,217.893,349.519,217.893Z",
    transform: "translate(-261.488 -171.567)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3953",
    "data-name": "Path 3953",
    d: "M325.546,276.041s.789-7.761-2.312-11.268-7.771.779-6.605,5.443S325.546,276.041,325.546,276.041Z",
    transform: "translate(-243.258 -207.499)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3954",
    "data-name": "Path 3954",
    d: "M317.5,316.679s-.852-7.764-4.624-10.538-7.441,2.374-5.33,6.694S317.5,316.679,317.5,316.679Z",
    transform: "translate(-236.883 -235.54)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3955",
    "data-name": "Path 3955",
    d: "M345.245,359.148c-4.591.885-8.706,7.526-8.706,7.526s6.876,3.8,10.638.812S349.839,358.267,345.245,359.148Z",
    transform: "translate(-256.715 -271.511)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3956",
    "data-name": "Path 3956",
    d: "M342.244,394.5c-6.572,1.265-12.454,10.766-12.454,10.766s9.838,5.439,15.221,1.159S348.816,393.238,342.244,394.5Z",
    transform: "translate(-252.195 -295.165)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3957",
    "data-name": "Path 3957",
    d: "M300.3,248h.33s-.043-.37-.145-.991c.525-2.943,1.057-6.645,1.688-11.07l.264-1.843c1.79.849,6.935,2.929,10,.489,3.762-2.992,2.662-9.221-1.932-8.336-3.322.637-6.394,4.293-7.837,6.258.406-2.807.849-5.826,1.347-8.986q.129-.8.287-1.668c1.767,1.3,6.09,4.036,9.432,2.371,4.293-2.143,4.518-8.468-.159-8.557-3.369-.063-7.114,2.844-8.943,4.475.66-3.329,1.608-7.173,2.6-10.971,1.073.806,3.933,2.678,6.133,1.582,2.761-1.377,2.9-5.433-.1-5.489-2.183-.043-4.6,1.856-5.766,2.9.8-3.025,1.625-5.981,2.374-8.587,1.235.875,3.824,2.384,5.849,1.374,2.758-1.377,2.9-5.433-.1-5.489-1.909-.036-4,1.407-5.284,2.47,1.1-3.788,1.955-6.582,2.176-7.305,1.116-.74,4.485-3.052,5.046-4.435a3.253,3.253,0,0,0-6.027-2.451c-.538,1.321.182,5.069.492,6.526l-.2-.063c-.03.089-1.149,3.709-2.592,8.725l-.089.089.049.043c-.776,2.708-1.651,5.816-2.487,8.99.046-1.506-.043-4.736-1.542-6.42-1.981-2.246-4.987.5-4.237,3.491.661,2.675,4.723,3.554,5.575,3.712-1.12,4.27-2.17,8.61-2.86,12.219l-.155.159.109.093c-.139.727-.261,1.427-.363,2.087-.71,4.5-1.321,8.712-1.843,12.431-.5,3.484-.931,6.519-1.351,9.085-.621-2.487-1.826-5.836-4.039-7.464-3.768-2.777-7.441,2.375-5.33,6.694,1.615,3.3,6.582,3.8,8.828,3.851-.086.443-.169.865-.254,1.268-.33,1.6-.879,6.014-1.41,10.855-.74-3.567-2.477-9.534-6.133-12.219-5.39-3.963-10.644,3.4-7.626,9.577,2.533,5.188,10.849,5.542,13.451,5.522-.713,6.76-1.348,13.468-1.4,13.983l.779.073c.023-.234,2.229-23.544,3.1-27.616C300.1,248.981,300.2,248.522,300.3,248Z",
    transform: "translate(-220.981 -152.734)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3958",
    "data-name": "Path 3958",
    d: "M124.747,148.05s-2.081-4.515-4.805-5.1-3.762,3.662-1.671,5.69S124.747,148.05,124.747,148.05Z",
    transform: "translate(-109.788 -126.731)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3959",
    "data-name": "Path 3959",
    d: "M135.693,210.023s-3.243-7.044-7.487-7.956-5.869,5.707-2.609,8.867S135.693,210.023,135.693,210.023Z",
    transform: "translate(-114.281 -166.306)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3960",
    "data-name": "Path 3960",
    d: "M149.077,249.838s-4.554-5.968-8.97-5.842-4.8,6.833-.954,9.092S149.077,249.838,149.077,249.838Z",
    transform: "translate(-122.747 -194.443)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3961",
    "data-name": "Path 3961",
    d: "M197.026,259.871c-3.256,3.729-3.256,11.982-3.256,11.982s7.427-1.275,8.963-6.235S200.286,256.139,197.026,259.871Z",
    transform: "translate(-161.096 -204.156)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3962",
    "data-name": "Path 3962",
    d: "M215.543,285.445c-4.66,5.337-4.663,17.144-4.663,17.144s10.624-1.823,12.827-8.917S220.2,280.108,215.543,285.445Z",
    transform: "translate(-172.555 -220.889)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3963",
    "data-name": "Path 3963",
    d: "M146.037,167.034l.258-.221s-.218-.284-.6-.73c-1.044-2.817-2.46-6.275-4.155-10.4l-.707-1.721c1.866-.449,7.038-2.044,8.289-6.09,1.539-4.954-2.447-9.478-5.707-5.746-2.355,2.695-3.005,7.758-3.187,10.353-1.073-2.622-2.219-5.449-3.392-8.431-.195-.5-.4-1.03-.6-1.585,2.071-.053,6.912-.568,8.768-4.141,2.394-4.6-.578-10.053-4.386-7.084-2.744,2.133-4.31,7.011-4.97,9.577-1.116-3.233-2.279-7.074-3.369-10.9,1.265-.02,4.5-.307,5.723-2.659,1.536-2.952-.37-6.45-2.814-4.548-1.777,1.384-2.781,4.557-3.2,6.186-.859-3.058-1.651-6.083-2.365-8.762,1.43-.066,4.264-.482,5.39-2.642,1.536-2.949-.37-6.45-2.814-4.544-1.552,1.209-2.517,3.781-3.012,5.5-.991-3.9-1.7-6.8-1.886-7.556.532-1.344,2.091-5.479,1.853-7.008a2.754,2.754,0,0,0-3.554-2.4,3.9,3.9,0,0,0-2.52,4.264c.228,1.47,2.672,4.145,3.633,5.165l-.192.076c.02.092.921,3.864,2.256,9.016-.016.079-.026.135-.026.135h.063c.723,2.784,1.569,5.945,2.474,9.171-.71-1.295-2.394-3.963-4.439-4.392-2.721-.591-3.765,3.659-1.671,5.687,1.869,1.813,5.571-.083,6.334-.505,1.225,4.316,2.543,8.649,3.788,12.137l-.046.234h.132q.383,1.053.746,1.982c1.651,4.241,3.283,8.174,4.706,11.645,1.321,3.25,2.5,6.083,3.438,8.511-1.737-1.684-4.376-3.715-6.968-3.633-4.412.119-4.8,6.833-.954,9.092,2.943,1.727,7.19-1.087,9.023-2.5q.228.637.426,1.228c.522,1.572,2.285,5.614,4.273,10.04-2.375-2.517-6.744-6.4-11.027-6.275-6.311.168-6.873,9.776-1.367,13.005,4.624,2.711,11.49-2.4,13.573-4.108,2.791,6.146,5.614,12.2,5.836,12.662l.661-.446c-.1-.215-9.931-21.235-11.258-25.225C146.371,167.982,146.209,167.516,146.037,167.034Z",
    transform: "translate(-113.723 -98.914)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3964",
    "data-name": "Path 3964",
    d: "M105.781,329.55s-2.266-2.11-3.963-1.81-1.321,3,.376,3.676S105.781,329.55,105.781,329.55Z",
    transform: "translate(-98.775 -250.513)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3965",
    "data-name": "Path 3965",
    d: "M127.288,361.938s-3.53-3.3-6.192-2.817-2.034,4.673.591,5.727S127.288,361.938,127.288,361.938Z",
    transform: "translate(-111.275 -271.517)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3966",
    "data-name": "Path 3966",
    d: "M144.28,381.464s-4.036-2.365-6.549-1.255-1.156,5.073,1.592,5.466S144.28,381.464,144.28,381.464Z",
    transform: "translate(-122.677 -285.474)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3967",
    "data-name": "Path 3967",
    d: "M176.659,375.243c-.991,2.916.951,7.675.951,7.675s3.963-2.49,3.7-5.71S177.656,372.324,176.659,375.243Z",
    transform: "translate(-149.447 -281.334)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3968",
    "data-name": "Path 3968",
    d: "M195.037,384.32c-1.427,4.174,1.367,11,1.367,11s5.694-3.56,5.284-8.17S196.46,380.142,195.037,384.32Z",
    transform: "translate(-161.673 -286.979)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3969",
    "data-name": "Path 3969",
    d: "M122.891,334.892c.063-.119.1-.188.1-.188s-.195-.112-.522-.277c-1.265-1.377-2.9-3.035-4.848-5.013l-.812-.826c.968-.7,3.57-2.84,3.339-5.466-.284-3.223-3.649-4.884-4.647-1.965-.72,2.11.1,5.182.608,6.721-1.238-1.258-2.563-2.616-3.943-4.059-.234-.244-.472-.5-.72-.773,1.179-.519,3.847-1.958,4.075-4.458.294-3.213-2.7-5.657-4.2-3.048-1.077,1.879-.826,5.059-.6,6.694-1.407-1.6-2.972-3.54-4.518-5.5.727-.31,2.523-1.238,2.672-2.883.188-2.064-1.737-3.633-2.695-1.955-.7,1.219-.528,3.283-.383,4.32-1.219-1.562-2.4-3.111-3.431-4.491.809-.377,2.342-1.285,2.48-2.8.188-2.064-1.737-3.633-2.695-1.958a7.076,7.076,0,0,0-.436,3.884c-1.5-2.008-2.589-3.517-2.87-3.91,0-.9-.089-3.649-.588-4.475a1.714,1.714,0,0,0-2.612-.542,2.421,2.421,0,0,0-.446,3.061c.476.793,2.517,1.76,3.3,2.117l-.092.089c.036.049,1.443,2.011,3.431,4.663l.017.086h.036c1.073,1.433,2.312,3.061,3.59,4.7-.713-.578-2.312-1.711-3.593-1.483-1.711.3-1.321,3,.376,3.672,1.506.6,3.194-1.364,3.534-1.787,1.724,2.2,3.507,4.386,5.046,6.1l.03.145.079-.026c.31.33.611.661.9.971,1.962,2.051,3.821,3.937,5.462,5.614,1.536,1.559,2.873,2.916,3.989,4.092-1.4-.561-3.4-1.106-4.875-.456-2.517,1.11-1.156,5.073,1.6,5.466,2.1.3,3.887-2.312,4.607-3.573.192.211.37.416.535.611.661.783,2.642,2.7,4.835,4.775-1.962-.888-5.4-2.1-7.84-1.02-3.6,1.589-1.651,7.266,2.282,7.82,3.3.469,6.057-4.1,6.853-5.571,3.061,2.883,6.12,5.7,6.354,5.915l.277-.413c-.106-.1-10.737-9.908-12.441-11.889C123.307,335.374,123.1,335.13,122.891,334.892Z",
    transform: "translate(-94.834 -232.981)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3970",
    "data-name": "Path 3970",
    d: "M316.176,116.07s.661-3.025-.472-4.34-3.243.406-2.972,2.2S316.176,116.07,316.176,116.07Z",
    transform: "translate(-240.754 -105.55)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3971",
    "data-name": "Path 3971",
    d: "M296.508,151.658s1.03-4.713-.733-6.764-5.056.634-4.624,3.428S296.508,151.658,296.508,151.658Z",
    transform: "translate(-226.291 -127.588)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3972",
    "data-name": "Path 3972",
    d: "M288.621,176.4s-.02-4.673-2.259-6.275-4.954,1.592-3.887,4.158S288.621,176.4,288.621,176.4Z",
    transform: "translate(-220.345 -144.682)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3973",
    "data-name": "Path 3973",
    d: "M303.25,201.257c-3.022.631-6.12,4.733-6.12,4.733s4.168,2.153,6.8.267S306.268,200.626,303.25,201.257Z",
    transform: "translate(-230.321 -165.773)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3974",
    "data-name": "Path 3974",
    d: "M298.455,222.516c-4.32.9-8.755,6.77-8.755,6.77s5.964,3.081,9.723.383S302.775,221.618,298.455,222.516Z",
    transform: "translate(-225.345 -179.992)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3975",
    "data-name": "Path 3975",
    d: "M272.929,134.262h.211s0-.221-.026-.588c.538-1.79,1.133-4.039,1.84-6.727q.142-.548.3-1.12c1.1.476,4.264,1.625,6.4.086,2.642-1.886,2.342-5.614-.66-5-2.183.456-4.409,2.728-5.472,3.963.452-1.707.945-3.54,1.483-5.462.089-.33.188-.66.3-1.014,1.047.75,3.633,2.312,5.912,1.235,2.916-1.384,3.487-5.211.482-5.168-2.166.033-4.775,1.869-6.067,2.893.661-2.028,1.526-4.373,2.424-6.688.637.466,2.351,1.536,3.844.829,1.869-.888,2.236-3.345.307-3.3-1.4.02-3.091,1.219-3.914,1.873.723-1.846,1.456-3.649,2.117-5.241.736.5,2.312,1.361,3.672.707,1.873-.888,2.236-3.345.307-3.3a6.979,6.979,0,0,0-3.563,1.6c.968-2.312,1.707-4.016,1.9-4.462.769-.469,3.094-1.935,3.553-2.784a1.717,1.717,0,0,0-.869-2.526,2.427,2.427,0,0,0-2.85,1.172c-.439.816-.231,3.061-.129,3.933l-.122-.033c-.026.056-.991,2.266-2.266,5.33l-.063.056.03.023c-.687,1.651-1.456,3.55-2.216,5.486.135-.908.294-2.86-.555-3.847-1.133-1.321-3.246.406-2.972,2.2.248,1.605,2.8,2.051,3.336,2.13-1.011,2.606-1.982,5.251-2.675,7.451l-.109.1.063.053c-.139.443-.264.869-.377,1.268-.763,2.735-1.44,5.284-2.034,7.553-.558,2.12-1.044,3.963-1.49,5.522-.228-1.489-.779-3.488-2.09-4.429-2.239-1.6-4.954,1.592-3.89,4.158.816,1.965,3.98,2.163,5.423,2.147-.083.271-.168.525-.251.77-.33.991-.991,3.656-1.651,6.605-.234-2.14-.948-5.713-3.118-7.266-3.2-2.289-7.087,2.275-5.565,5.945,1.278,3.085,6.605,3.124,8.286,3.058-.921,4.1-1.787,8.17-1.853,8.481l.5.03c.03-.145,3.038-14.28,3.877-16.76C272.737,134.843,272.833,134.552,272.929,134.262Z",
    transform: "translate(-206.457 -93.956)",
    fill: "#033096"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-21",
    transform: "translate(51.372 61.927)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_848",
    "data-name": "Rectangle 848",
    width: 27.49,
    height: 3.953,
    transform: "translate(23.864 83.178)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    y2: 2.804,
    transform: "translate(25.373 83.251)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    y1: 3.101,
    transform: "translate(26.876 83.852)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    y2: 3.405,
    transform: "translate(28.778 83.251)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    y2: 2.5,
    transform: "translate(30.879 83.151)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    y2: 3.504,
    transform: "translate(32.781 83.35)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    y1: 2.1,
    transform: "translate(34.683 84.852)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    y2: 2.005,
    transform: "translate(36.384 83.35)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    y1: 1.202,
    transform: "translate(38.785 85.153)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_849",
    "data-name": "Rectangle 849",
    width: 1.628,
    height: 3.682,
    transform: "translate(41.916 83.32)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_850",
    "data-name": "Rectangle 850",
    width: 0.515,
    height: 3.682,
    transform: "translate(44.142 83.32)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_851",
    "data-name": "Rectangle 851",
    width: 27.49,
    height: 3.953,
    transform: "translate(22.54 79.215)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    y2: 2.804,
    transform: "translate(24.052 79.288)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    y1: 3.101,
    transform: "translate(25.555 79.889)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    y2: 3.405,
    transform: "translate(27.457 79.288)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    y2: 2.5,
    transform: "translate(29.558 79.188)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    y2: 3.504,
    transform: "translate(31.46 79.387)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    y1: 2.1,
    transform: "translate(33.362 80.889)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    y2: 2.005,
    transform: "translate(35.063 79.387)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    y1: 1.202,
    transform: "translate(37.464 81.19)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_852",
    "data-name": "Rectangle 852",
    width: 1.628,
    height: 3.682,
    transform: "translate(40.595 79.357)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_853",
    "data-name": "Rectangle 853",
    width: 0.515,
    height: 3.682,
    transform: "translate(42.821 79.357)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_854",
    "data-name": "Rectangle 854",
    width: 27.49,
    height: 3.953,
    transform: "translate(23.534 75.252)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    y2: 2.804,
    transform: "translate(25.043 75.324)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    y1: 3.101,
    transform: "translate(26.546 75.926)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    y2: 3.405,
    transform: "translate(28.448 75.324)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    y2: 2.5,
    transform: "translate(30.549 75.225)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    y2: 3.504,
    transform: "translate(32.451 75.424)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    y1: 2.1,
    transform: "translate(34.353 76.926)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    y2: 2.005,
    transform: "translate(36.054 75.424)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    y1: 1.202,
    transform: "translate(38.455 77.227)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_855",
    "data-name": "Rectangle 855",
    width: 1.628,
    height: 3.682,
    transform: "translate(41.586 75.394)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_856",
    "data-name": "Rectangle 856",
    width: 0.515,
    height: 3.682,
    transform: "translate(43.812 75.394)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_857",
    "data-name": "Rectangle 857",
    width: 27.49,
    height: 3.953,
    transform: "translate(22.54 71.289)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    y2: 2.804,
    transform: "translate(24.052 71.361)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    y1: 3.101,
    transform: "translate(25.555 71.962)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    y2: 3.405,
    transform: "translate(27.457 71.361)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    y2: 2.5,
    transform: "translate(29.558 71.262)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    y2: 3.504,
    transform: "translate(31.46 71.46)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    y1: 2.1,
    transform: "translate(33.362 72.963)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    y2: 2.005,
    transform: "translate(35.063 71.46)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    y1: 1.202,
    transform: "translate(37.464 73.264)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_858",
    "data-name": "Rectangle 858",
    width: 1.628,
    height: 3.682,
    transform: "translate(40.595 71.431)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_859",
    "data-name": "Rectangle 859",
    width: 0.515,
    height: 3.682,
    transform: "translate(42.821 71.431)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_860",
    "data-name": "Rectangle 860",
    width: 27.49,
    height: 3.953,
    transform: "translate(23.534 67.326)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    y2: 2.804,
    transform: "translate(25.043 67.398)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    y1: 3.101,
    transform: "translate(26.546 67.999)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    y2: 3.405,
    transform: "translate(28.448 67.398)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    y2: 2.5,
    transform: "translate(30.549 67.299)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    y2: 3.504,
    transform: "translate(32.451 67.497)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    y1: 2.1,
    transform: "translate(34.353 69)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    y2: 2.005,
    transform: "translate(36.054 67.497)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    y1: 1.202,
    transform: "translate(38.455 69.301)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_861",
    "data-name": "Rectangle 861",
    width: 1.628,
    height: 3.682,
    transform: "translate(41.586 67.468)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_862",
    "data-name": "Rectangle 862",
    width: 0.515,
    height: 3.682,
    transform: "translate(43.812 67.468)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_863",
    "data-name": "Rectangle 863",
    width: 27.49,
    height: 3.953,
    transform: "translate(23.534 63.363)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    y2: 2.804,
    transform: "translate(25.043 63.435)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    y1: 3.101,
    transform: "translate(26.546 64.036)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    y2: 3.405,
    transform: "translate(28.448 63.435)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    y2: 2.5,
    transform: "translate(30.549 63.336)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    y2: 3.504,
    transform: "translate(32.451 63.534)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    y1: 2.1,
    transform: "translate(34.353 65.037)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    y2: 2.005,
    transform: "translate(36.054 63.534)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    y1: 1.202,
    transform: "translate(38.455 65.338)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_864",
    "data-name": "Rectangle 864",
    width: 1.628,
    height: 3.682,
    transform: "translate(41.586 63.505)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_865",
    "data-name": "Rectangle 865",
    width: 0.515,
    height: 3.682,
    transform: "translate(43.812 63.505)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_866",
    "data-name": "Rectangle 866",
    width: 27.49,
    height: 3.953,
    transform: "translate(23.204 59.4)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    y2: 2.804,
    transform: "translate(24.713 59.472)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    y1: 3.101,
    transform: "translate(26.216 60.073)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    y2: 3.405,
    transform: "translate(28.118 59.472)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    y2: 2.5,
    transform: "translate(30.218 59.373)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    y2: 3.504,
    transform: "translate(32.121 59.571)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    y1: 2.1,
    transform: "translate(34.023 61.074)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    "data-name": "Line 62",
    y2: 2.005,
    transform: "translate(35.724 59.571)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    y1: 1.202,
    transform: "translate(38.125 61.374)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_867",
    "data-name": "Rectangle 867",
    width: 1.628,
    height: 3.682,
    transform: "translate(41.255 59.542)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_868",
    "data-name": "Rectangle 868",
    width: 0.515,
    height: 3.682,
    transform: "translate(43.481 59.542)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_869",
    "data-name": "Rectangle 869",
    width: 27.49,
    height: 3.953,
    transform: "translate(21.549 55.437)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    y2: 2.804,
    transform: "translate(23.062 55.509)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    y1: 3.101,
    transform: "translate(24.564 56.11)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    y2: 3.405,
    transform: "translate(26.467 55.509)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    y2: 2.5,
    transform: "translate(28.567 55.41)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_68",
    "data-name": "Line 68",
    y2: 3.504,
    transform: "translate(30.469 55.608)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    "data-name": "Line 69",
    y1: 2.1,
    transform: "translate(32.372 57.111)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_70",
    "data-name": "Line 70",
    y2: 2.005,
    transform: "translate(34.072 55.608)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_71",
    "data-name": "Line 71",
    y1: 1.202,
    transform: "translate(36.473 57.411)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_870",
    "data-name": "Rectangle 870",
    width: 1.628,
    height: 3.682,
    transform: "translate(39.604 55.579)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_871",
    "data-name": "Rectangle 871",
    width: 0.515,
    height: 3.682,
    transform: "translate(41.83 55.579)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_872",
    "data-name": "Rectangle 872",
    width: 27.49,
    height: 3.953,
    transform: "translate(21.879 51.473)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    y2: 2.804,
    transform: "translate(23.392 51.546)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    "data-name": "Line 73",
    y1: 3.101,
    transform: "translate(24.895 52.147)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_74",
    "data-name": "Line 74",
    y2: 3.405,
    transform: "translate(26.797 51.546)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_75",
    "data-name": "Line 75",
    y2: 2.5,
    transform: "translate(28.897 51.447)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_76",
    "data-name": "Line 76",
    y2: 3.504,
    transform: "translate(30.8 51.645)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_77",
    "data-name": "Line 77",
    y1: 2.1,
    transform: "translate(32.702 53.148)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_78",
    "data-name": "Line 78",
    y2: 2.005,
    transform: "translate(34.403 51.645)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_79",
    "data-name": "Line 79",
    y1: 1.202,
    transform: "translate(36.804 53.448)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_873",
    "data-name": "Rectangle 873",
    width: 1.628,
    height: 3.682,
    transform: "translate(39.934 51.615)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_874",
    "data-name": "Rectangle 874",
    width: 0.515,
    height: 3.682,
    transform: "translate(42.16 51.615)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_875",
    "data-name": "Rectangle 875",
    width: 27.49,
    height: 3.953,
    transform: "translate(21.549 47.51)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_80",
    "data-name": "Line 80",
    y2: 2.804,
    transform: "translate(23.062 47.583)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_81",
    "data-name": "Line 81",
    y1: 3.101,
    transform: "translate(24.564 48.184)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    y2: 3.405,
    transform: "translate(26.467 47.583)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_83",
    "data-name": "Line 83",
    y2: 2.5,
    transform: "translate(28.567 47.484)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    y2: 3.504,
    transform: "translate(30.469 47.682)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    y1: 2.1,
    transform: "translate(32.372 49.185)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    y2: 2.005,
    transform: "translate(34.072 47.682)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87",
    "data-name": "Line 87",
    y1: 1.202,
    transform: "translate(36.473 49.485)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_876",
    "data-name": "Rectangle 876",
    width: 1.628,
    height: 3.682,
    transform: "translate(39.604 47.652)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_877",
    "data-name": "Rectangle 877",
    width: 0.515,
    height: 3.682,
    transform: "translate(41.83 47.652)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_878",
    "data-name": "Rectangle 878",
    width: 27.49,
    height: 3.953,
    transform: "translate(23.534 43.547)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_88",
    "data-name": "Line 88",
    y2: 2.804,
    transform: "translate(25.043 43.62)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    "data-name": "Line 89",
    y1: 3.101,
    transform: "translate(26.546 44.221)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_90",
    "data-name": "Line 90",
    y2: 3.405,
    transform: "translate(28.448 43.62)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_91",
    "data-name": "Line 91",
    y2: 2.5,
    transform: "translate(30.549 43.521)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_92",
    "data-name": "Line 92",
    y2: 3.504,
    transform: "translate(32.451 43.719)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_93",
    "data-name": "Line 93",
    y1: 2.1,
    transform: "translate(34.353 45.222)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_94",
    "data-name": "Line 94",
    y2: 2.005,
    transform: "translate(36.054 43.719)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_95",
    "data-name": "Line 95",
    y1: 1.202,
    transform: "translate(38.455 45.522)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_879",
    "data-name": "Rectangle 879",
    width: 1.628,
    height: 3.682,
    transform: "translate(41.586 43.689)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_880",
    "data-name": "Rectangle 880",
    width: 0.515,
    height: 3.682,
    transform: "translate(43.812 43.689)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_881",
    "data-name": "Rectangle 881",
    width: 27.49,
    height: 3.953,
    transform: "translate(22.54 39.657)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_96",
    "data-name": "Line 96",
    y2: 2.804,
    transform: "translate(24.052 39.73)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_97",
    "data-name": "Line 97",
    y1: 3.104,
    transform: "translate(25.555 40.331)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    "data-name": "Line 98",
    y2: 3.405,
    transform: "translate(27.457 39.73)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_99",
    "data-name": "Line 99",
    y2: 2.503,
    transform: "translate(29.558 39.631)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    "data-name": "Line 100",
    y2: 3.501,
    transform: "translate(31.46 39.832)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_101",
    "data-name": "Line 101",
    y1: 2.104,
    transform: "translate(33.362 41.331)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_102",
    "data-name": "Line 102",
    y2: 2.001,
    transform: "translate(35.063 39.832)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_103",
    "data-name": "Line 103",
    y1: 1.202,
    transform: "translate(37.464 41.632)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_882",
    "data-name": "Rectangle 882",
    width: 1.628,
    height: 3.682,
    transform: "translate(40.595 39.802)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_883",
    "data-name": "Rectangle 883",
    width: 0.515,
    height: 3.682,
    transform: "translate(42.821 39.802)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_884",
    "data-name": "Rectangle 884",
    width: 27.49,
    height: 3.953,
    transform: "translate(23.534 35.694)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_104",
    "data-name": "Line 104",
    y2: 2.804,
    transform: "translate(25.043 35.767)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_105",
    "data-name": "Line 105",
    y1: 3.104,
    transform: "translate(26.546 36.368)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_106",
    "data-name": "Line 106",
    y2: 3.405,
    transform: "translate(28.448 35.767)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    y2: 2.503,
    transform: "translate(30.549 35.667)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_108",
    "data-name": "Line 108",
    y2: 3.501,
    transform: "translate(32.451 35.869)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_109",
    "data-name": "Line 109",
    y1: 2.104,
    transform: "translate(34.353 37.368)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_110",
    "data-name": "Line 110",
    y2: 2.001,
    transform: "translate(36.054 35.869)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_111",
    "data-name": "Line 111",
    y1: 1.202,
    transform: "translate(38.455 37.669)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_885",
    "data-name": "Rectangle 885",
    width: 1.628,
    height: 3.682,
    transform: "translate(41.586 35.839)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_886",
    "data-name": "Rectangle 886",
    width: 0.515,
    height: 3.682,
    transform: "translate(43.812 35.839)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_887",
    "data-name": "Rectangle 887",
    width: 27.49,
    height: 3.953,
    transform: "translate(22.54 31.731)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_112",
    "data-name": "Line 112",
    y2: 2.804,
    transform: "translate(24.052 31.804)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_113",
    "data-name": "Line 113",
    y1: 3.104,
    transform: "translate(25.555 32.405)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_114",
    "data-name": "Line 114",
    y2: 3.405,
    transform: "translate(27.457 31.804)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_115",
    "data-name": "Line 115",
    y2: 2.503,
    transform: "translate(29.558 31.704)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_116",
    "data-name": "Line 116",
    y2: 3.501,
    transform: "translate(31.46 31.906)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_117",
    "data-name": "Line 117",
    y1: 2.104,
    transform: "translate(33.362 33.405)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_118",
    "data-name": "Line 118",
    y2: 2.001,
    transform: "translate(35.063 31.906)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_119",
    "data-name": "Line 119",
    y1: 1.202,
    transform: "translate(37.464 33.706)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_888",
    "data-name": "Rectangle 888",
    width: 1.628,
    height: 3.682,
    transform: "translate(40.595 31.876)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_889",
    "data-name": "Rectangle 889",
    width: 0.515,
    height: 3.682,
    transform: "translate(42.821 31.876)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_890",
    "data-name": "Rectangle 890",
    width: 27.49,
    height: 3.953,
    transform: "translate(22.54 27.768)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_120",
    "data-name": "Line 120",
    y2: 2.804,
    transform: "translate(24.052 27.84)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_121",
    "data-name": "Line 121",
    y1: 3.104,
    transform: "translate(25.555 28.442)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_122",
    "data-name": "Line 122",
    y2: 3.405,
    transform: "translate(27.457 27.84)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_123",
    "data-name": "Line 123",
    y2: 2.503,
    transform: "translate(29.558 27.741)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_124",
    "data-name": "Line 124",
    y2: 3.501,
    transform: "translate(31.46 27.943)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_125",
    "data-name": "Line 125",
    y1: 2.104,
    transform: "translate(33.362 29.442)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_126",
    "data-name": "Line 126",
    y2: 2.001,
    transform: "translate(35.063 27.943)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_127",
    "data-name": "Line 127",
    y1: 1.202,
    transform: "translate(37.464 29.743)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_891",
    "data-name": "Rectangle 891",
    width: 1.628,
    height: 3.682,
    transform: "translate(40.595 27.913)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_892",
    "data-name": "Rectangle 892",
    width: 0.515,
    height: 3.682,
    transform: "translate(42.821 27.913)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_893",
    "data-name": "Rectangle 893",
    width: 27.49,
    height: 3.953,
    transform: "translate(22.54 23.805)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_128",
    "data-name": "Line 128",
    y2: 2.804,
    transform: "translate(24.052 23.877)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_129",
    "data-name": "Line 129",
    y1: 3.104,
    transform: "translate(25.555 24.478)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_130",
    "data-name": "Line 130",
    y2: 3.405,
    transform: "translate(27.457 23.877)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_131",
    "data-name": "Line 131",
    y2: 2.503,
    transform: "translate(29.558 23.778)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_132",
    "data-name": "Line 132",
    y2: 3.501,
    transform: "translate(31.46 23.98)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_133",
    "data-name": "Line 133",
    y1: 2.104,
    transform: "translate(33.362 25.479)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_134",
    "data-name": "Line 134",
    y2: 2.001,
    transform: "translate(35.063 23.98)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_135",
    "data-name": "Line 135",
    y1: 1.202,
    transform: "translate(37.464 25.78)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_894",
    "data-name": "Rectangle 894",
    width: 1.628,
    height: 3.682,
    transform: "translate(40.595 23.95)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_895",
    "data-name": "Rectangle 895",
    width: 0.515,
    height: 3.682,
    transform: "translate(42.821 23.95)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_896",
    "data-name": "Rectangle 896",
    width: 27.49,
    height: 3.953,
    transform: "translate(21.219 19.842)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_136",
    "data-name": "Line 136",
    y2: 2.804,
    transform: "translate(22.731 19.914)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_137",
    "data-name": "Line 137",
    y1: 3.104,
    transform: "translate(24.234 20.515)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_138",
    "data-name": "Line 138",
    y2: 3.405,
    transform: "translate(26.136 19.914)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_139",
    "data-name": "Line 139",
    y2: 2.503,
    transform: "translate(28.237 19.815)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_140",
    "data-name": "Line 140",
    y2: 3.501,
    transform: "translate(30.139 20.017)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_141",
    "data-name": "Line 141",
    y1: 2.104,
    transform: "translate(32.041 21.516)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_142",
    "data-name": "Line 142",
    y2: 2.001,
    transform: "translate(33.742 20.017)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_143",
    "data-name": "Line 143",
    y1: 1.202,
    transform: "translate(36.143 21.817)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_897",
    "data-name": "Rectangle 897",
    width: 1.628,
    height: 3.682,
    transform: "translate(39.274 19.987)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_898",
    "data-name": "Rectangle 898",
    width: 0.515,
    height: 3.682,
    transform: "translate(41.5 19.987)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_899",
    "data-name": "Rectangle 899",
    width: 27.49,
    height: 3.953,
    transform: "translate(22.54 15.879)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_144",
    "data-name": "Line 144",
    y2: 2.804,
    transform: "translate(24.052 15.951)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_145",
    "data-name": "Line 145",
    y1: 3.104,
    transform: "translate(25.555 16.552)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_146",
    "data-name": "Line 146",
    y2: 3.405,
    transform: "translate(27.457 15.951)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_147",
    "data-name": "Line 147",
    y2: 2.503,
    transform: "translate(29.558 15.852)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_148",
    "data-name": "Line 148",
    y2: 3.501,
    transform: "translate(31.46 16.054)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_149",
    "data-name": "Line 149",
    y1: 2.104,
    transform: "translate(33.362 17.553)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_150",
    "data-name": "Line 150",
    y2: 2.001,
    transform: "translate(35.063 16.054)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_151",
    "data-name": "Line 151",
    y1: 1.202,
    transform: "translate(37.464 17.854)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_900",
    "data-name": "Rectangle 900",
    width: 1.628,
    height: 3.682,
    transform: "translate(40.595 16.024)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_901",
    "data-name": "Rectangle 901",
    width: 0.515,
    height: 3.682,
    transform: "translate(42.821 16.024)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_902",
    "data-name": "Rectangle 902",
    width: 27.49,
    height: 3.953,
    transform: "translate(20.889 11.916)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_152",
    "data-name": "Line 152",
    y2: 2.804,
    transform: "translate(22.401 11.988)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_153",
    "data-name": "Line 153",
    y1: 3.104,
    transform: "translate(23.904 12.589)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_154",
    "data-name": "Line 154",
    y2: 3.405,
    transform: "translate(25.806 11.988)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_155",
    "data-name": "Line 155",
    y2: 2.503,
    transform: "translate(27.907 11.889)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_156",
    "data-name": "Line 156",
    y2: 3.501,
    transform: "translate(29.809 12.091)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_157",
    "data-name": "Line 157",
    y1: 2.104,
    transform: "translate(31.711 13.59)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_158",
    "data-name": "Line 158",
    y2: 2.001,
    transform: "translate(33.412 12.091)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_159",
    "data-name": "Line 159",
    y1: 1.202,
    transform: "translate(35.813 13.891)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_903",
    "data-name": "Rectangle 903",
    width: 1.628,
    height: 3.682,
    transform: "translate(38.944 12.061)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_904",
    "data-name": "Rectangle 904",
    width: 0.515,
    height: 3.682,
    transform: "translate(41.17 12.061)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_905",
    "data-name": "Rectangle 905",
    width: 27.49,
    height: 3.953,
    transform: "translate(22.54 7.953)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_160",
    "data-name": "Line 160",
    y2: 2.804,
    transform: "translate(24.052 8.025)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_161",
    "data-name": "Line 161",
    y1: 3.104,
    transform: "translate(25.555 8.626)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_162",
    "data-name": "Line 162",
    y2: 3.405,
    transform: "translate(27.457 8.025)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_163",
    "data-name": "Line 163",
    y2: 2.503,
    transform: "translate(29.558 7.926)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_164",
    "data-name": "Line 164",
    y2: 3.501,
    transform: "translate(31.46 8.128)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_165",
    "data-name": "Line 165",
    y1: 2.104,
    transform: "translate(33.362 9.627)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_166",
    "data-name": "Line 166",
    y2: 2.001,
    transform: "translate(35.063 8.128)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_167",
    "data-name": "Line 167",
    y1: 1.202,
    transform: "translate(37.464 9.927)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_906",
    "data-name": "Rectangle 906",
    width: 1.628,
    height: 3.682,
    transform: "translate(40.595 8.098)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_907",
    "data-name": "Rectangle 907",
    width: 0.515,
    height: 3.682,
    transform: "translate(42.821 8.098)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_908",
    "data-name": "Rectangle 908",
    width: 27.49,
    height: 3.953,
    transform: "translate(21.219 3.989)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_168",
    "data-name": "Line 168",
    y2: 2.804,
    transform: "translate(22.731 4.062)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_169",
    "data-name": "Line 169",
    y1: 3.104,
    transform: "translate(24.234 4.663)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_170",
    "data-name": "Line 170",
    y2: 3.405,
    transform: "translate(26.136 4.062)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_171",
    "data-name": "Line 171",
    y2: 2.503,
    transform: "translate(28.237 3.963)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_172",
    "data-name": "Line 172",
    y2: 3.501,
    transform: "translate(30.139 4.165)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_173",
    "data-name": "Line 173",
    y1: 2.104,
    transform: "translate(32.041 5.664)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_174",
    "data-name": "Line 174",
    y2: 2.001,
    transform: "translate(33.742 4.165)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_175",
    "data-name": "Line 175",
    y1: 1.202,
    transform: "translate(36.143 5.964)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_909",
    "data-name": "Rectangle 909",
    width: 1.628,
    height: 3.682,
    transform: "translate(39.274 4.135)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_910",
    "data-name": "Rectangle 910",
    width: 0.515,
    height: 3.682,
    transform: "translate(41.5 4.135)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_911",
    "data-name": "Rectangle 911",
    width: 27.49,
    height: 3.953,
    transform: "translate(22.54 0.026)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_176",
    "data-name": "Line 176",
    y2: 2.804,
    transform: "translate(24.052 0.099)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_177",
    "data-name": "Line 177",
    y1: 3.104,
    transform: "translate(25.555 0.7)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_178",
    "data-name": "Line 178",
    y2: 3.405,
    transform: "translate(27.457 0.099)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_179",
    "data-name": "Line 179",
    y2: 2.503,
    transform: "translate(29.558)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_180",
    "data-name": "Line 180",
    y2: 3.501,
    transform: "translate(31.46 0.201)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_181",
    "data-name": "Line 181",
    y1: 2.104,
    transform: "translate(33.362 1.701)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_182",
    "data-name": "Line 182",
    y2: 2.001,
    transform: "translate(35.063 0.201)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_183",
    "data-name": "Line 183",
    y1: 1.202,
    transform: "translate(37.464 2.001)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_912",
    "data-name": "Rectangle 912",
    width: 1.628,
    height: 3.682,
    transform: "translate(40.595 0.172)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_913",
    "data-name": "Rectangle 913",
    width: 0.515,
    height: 3.682,
    transform: "translate(42.821 0.172)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_914",
    "data-name": "Rectangle 914",
    width: 27.49,
    height: 3.953,
    transform: "translate(1.651 83.178)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_184",
    "data-name": "Line 184",
    y2: 2.804,
    transform: "translate(3.164 83.251)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_185",
    "data-name": "Line 185",
    y1: 3.101,
    transform: "translate(4.663 83.852)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_186",
    "data-name": "Line 186",
    y2: 3.405,
    transform: "translate(6.565 83.251)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_187",
    "data-name": "Line 187",
    y2: 2.5,
    transform: "translate(8.669 83.151)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_188",
    "data-name": "Line 188",
    y2: 3.504,
    transform: "translate(10.571 83.35)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_189",
    "data-name": "Line 189",
    y1: 2.1,
    transform: "translate(12.47 84.852)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_190",
    "data-name": "Line 190",
    y2: 2.005,
    transform: "translate(14.175 83.35)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_191",
    "data-name": "Line 191",
    y1: 1.202,
    transform: "translate(16.575 85.153)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_915",
    "data-name": "Rectangle 915",
    width: 1.628,
    height: 3.682,
    transform: "translate(19.706 83.32)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_916",
    "data-name": "Rectangle 916",
    width: 0.515,
    height: 3.682,
    transform: "translate(21.932 83.32)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_917",
    "data-name": "Rectangle 917",
    width: 27.49,
    height: 3.953,
    transform: "translate(1.651 79.215)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_192",
    "data-name": "Line 192",
    y2: 2.804,
    transform: "translate(3.164 79.288)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_193",
    "data-name": "Line 193",
    y1: 3.101,
    transform: "translate(4.663 79.889)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_194",
    "data-name": "Line 194",
    y2: 3.405,
    transform: "translate(6.565 79.288)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_195",
    "data-name": "Line 195",
    y2: 2.5,
    transform: "translate(8.669 79.188)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_196",
    "data-name": "Line 196",
    y2: 3.504,
    transform: "translate(10.571 79.387)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_197",
    "data-name": "Line 197",
    y1: 2.1,
    transform: "translate(12.47 80.889)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_198",
    "data-name": "Line 198",
    y2: 2.005,
    transform: "translate(14.175 79.387)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_199",
    "data-name": "Line 199",
    y1: 1.202,
    transform: "translate(16.575 81.19)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_918",
    "data-name": "Rectangle 918",
    width: 1.628,
    height: 3.682,
    transform: "translate(19.706 79.357)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_919",
    "data-name": "Rectangle 919",
    width: 0.515,
    height: 3.682,
    transform: "translate(21.932 79.357)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_920",
    "data-name": "Rectangle 920",
    width: 27.49,
    height: 3.953,
    transform: "translate(3.303 75.252)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_200",
    "data-name": "Line 200",
    y2: 2.804,
    transform: "translate(4.815 75.324)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_201",
    "data-name": "Line 201",
    y1: 3.101,
    transform: "translate(6.314 75.926)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_202",
    "data-name": "Line 202",
    y2: 3.405,
    transform: "translate(8.217 75.324)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_203",
    "data-name": "Line 203",
    y2: 2.5,
    transform: "translate(10.32 75.225)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_204",
    "data-name": "Line 204",
    y2: 3.504,
    transform: "translate(12.223 75.424)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_205",
    "data-name": "Line 205",
    y1: 2.1,
    transform: "translate(14.122 76.926)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_206",
    "data-name": "Line 206",
    y2: 2.005,
    transform: "translate(15.826 75.424)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_207",
    "data-name": "Line 207",
    y1: 1.202,
    transform: "translate(18.227 77.227)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_921",
    "data-name": "Rectangle 921",
    width: 1.628,
    height: 3.682,
    transform: "translate(21.358 75.394)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_922",
    "data-name": "Rectangle 922",
    width: 0.515,
    height: 3.682,
    transform: "translate(23.583 75.394)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_923",
    "data-name": "Rectangle 923",
    width: 27.49,
    height: 3.953,
    transform: "translate(1.982 71.289)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_208",
    "data-name": "Line 208",
    y2: 2.804,
    transform: "translate(3.494 71.361)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_209",
    "data-name": "Line 209",
    y1: 3.101,
    transform: "translate(4.993 71.962)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_210",
    "data-name": "Line 210",
    y2: 3.405,
    transform: "translate(6.896 71.361)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_211",
    "data-name": "Line 211",
    y2: 2.5,
    transform: "translate(8.999 71.262)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_212",
    "data-name": "Line 212",
    y2: 3.504,
    transform: "translate(10.902 71.46)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_213",
    "data-name": "Line 213",
    y1: 2.1,
    transform: "translate(12.801 72.963)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_214",
    "data-name": "Line 214",
    y2: 2.005,
    transform: "translate(14.505 71.46)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_215",
    "data-name": "Line 215",
    y1: 1.202,
    transform: "translate(16.906 73.264)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_924",
    "data-name": "Rectangle 924",
    width: 1.628,
    height: 3.682,
    transform: "translate(20.037 71.431)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_925",
    "data-name": "Rectangle 925",
    width: 0.515,
    height: 3.682,
    transform: "translate(22.262 71.431)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_926",
    "data-name": "Rectangle 926",
    width: 27.49,
    height: 3.953,
    transform: "translate(3.303 67.326)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_216",
    "data-name": "Line 216",
    y2: 2.804,
    transform: "translate(4.815 67.398)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_217",
    "data-name": "Line 217",
    y1: 3.101,
    transform: "translate(6.314 67.999)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_218",
    "data-name": "Line 218",
    y2: 3.405,
    transform: "translate(8.217 67.398)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_219",
    "data-name": "Line 219",
    y2: 2.5,
    transform: "translate(10.32 67.299)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_220",
    "data-name": "Line 220",
    y2: 3.504,
    transform: "translate(12.223 67.497)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_221",
    "data-name": "Line 221",
    y1: 2.1,
    transform: "translate(14.122 69)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_222",
    "data-name": "Line 222",
    y2: 2.005,
    transform: "translate(15.826 67.497)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_223",
    "data-name": "Line 223",
    y1: 1.202,
    transform: "translate(18.227 69.301)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_927",
    "data-name": "Rectangle 927",
    width: 1.628,
    height: 3.682,
    transform: "translate(21.358 67.468)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_928",
    "data-name": "Rectangle 928",
    width: 0.515,
    height: 3.682,
    transform: "translate(23.583 67.468)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_929",
    "data-name": "Rectangle 929",
    width: 27.49,
    height: 3.953,
    transform: "translate(1.651 63.363)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_224",
    "data-name": "Line 224",
    y2: 2.804,
    transform: "translate(3.164 63.435)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_225",
    "data-name": "Line 225",
    y1: 3.101,
    transform: "translate(4.663 64.036)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_226",
    "data-name": "Line 226",
    y2: 3.405,
    transform: "translate(6.565 63.435)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_227",
    "data-name": "Line 227",
    y2: 2.5,
    transform: "translate(8.669 63.336)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_228",
    "data-name": "Line 228",
    y2: 3.504,
    transform: "translate(10.571 63.534)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_229",
    "data-name": "Line 229",
    y1: 2.1,
    transform: "translate(12.47 65.037)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_230",
    "data-name": "Line 230",
    y2: 2.005,
    transform: "translate(14.175 63.534)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_231",
    "data-name": "Line 231",
    y1: 1.202,
    transform: "translate(16.575 65.338)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_930",
    "data-name": "Rectangle 930",
    width: 1.628,
    height: 3.682,
    transform: "translate(19.706 63.505)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_931",
    "data-name": "Rectangle 931",
    width: 0.515,
    height: 3.682,
    transform: "translate(21.932 63.505)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_932",
    "data-name": "Rectangle 932",
    width: 27.49,
    height: 3.953,
    transform: "translate(0.991 59.4)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_232",
    "data-name": "Line 232",
    y2: 2.804,
    transform: "translate(2.503 59.472)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_233",
    "data-name": "Line 233",
    y1: 3.101,
    transform: "translate(4.003 60.073)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_234",
    "data-name": "Line 234",
    y2: 3.405,
    transform: "translate(5.905 59.472)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_235",
    "data-name": "Line 235",
    y2: 2.5,
    transform: "translate(8.009 59.373)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_236",
    "data-name": "Line 236",
    y2: 3.504,
    transform: "translate(9.911 59.571)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_237",
    "data-name": "Line 237",
    y1: 2.1,
    transform: "translate(11.81 61.074)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_238",
    "data-name": "Line 238",
    y2: 2.005,
    transform: "translate(13.514 59.571)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_239",
    "data-name": "Line 239",
    y1: 1.202,
    transform: "translate(15.915 61.374)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_933",
    "data-name": "Rectangle 933",
    width: 1.628,
    height: 3.682,
    transform: "translate(19.046 59.542)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_934",
    "data-name": "Rectangle 934",
    width: 0.515,
    height: 3.682,
    transform: "translate(21.272 59.542)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_935",
    "data-name": "Rectangle 935",
    width: 27.49,
    height: 3.953,
    transform: "translate(1.321 55.437)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_240",
    "data-name": "Line 240",
    y2: 2.804,
    transform: "translate(2.834 55.509)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_241",
    "data-name": "Line 241",
    y1: 3.101,
    transform: "translate(4.333 56.11)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_242",
    "data-name": "Line 242",
    y2: 3.405,
    transform: "translate(6.235 55.509)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_243",
    "data-name": "Line 243",
    y2: 2.5,
    transform: "translate(8.339 55.41)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_244",
    "data-name": "Line 244",
    y2: 3.504,
    transform: "translate(10.241 55.608)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_245",
    "data-name": "Line 245",
    y1: 2.1,
    transform: "translate(12.14 57.111)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_246",
    "data-name": "Line 246",
    y2: 2.005,
    transform: "translate(13.844 55.608)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_247",
    "data-name": "Line 247",
    y1: 1.202,
    transform: "translate(16.245 57.411)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_936",
    "data-name": "Rectangle 936",
    width: 1.628,
    height: 3.682,
    transform: "translate(19.376 55.579)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_937",
    "data-name": "Rectangle 937",
    width: 0.515,
    height: 3.682,
    transform: "translate(21.602 55.579)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_938",
    "data-name": "Rectangle 938",
    width: 27.49,
    height: 3.953,
    transform: "translate(0 51.473)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_248",
    "data-name": "Line 248",
    y2: 2.804,
    transform: "translate(1.513 51.546)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_249",
    "data-name": "Line 249",
    y1: 3.101,
    transform: "translate(3.012 52.147)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_250",
    "data-name": "Line 250",
    y2: 3.405,
    transform: "translate(4.914 51.546)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_251",
    "data-name": "Line 251",
    y2: 2.5,
    transform: "translate(7.018 51.447)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_252",
    "data-name": "Line 252",
    y2: 3.504,
    transform: "translate(8.917 51.645)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_253",
    "data-name": "Line 253",
    y1: 2.1,
    transform: "translate(10.819 53.148)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_254",
    "data-name": "Line 254",
    y2: 2.005,
    transform: "translate(12.523 51.645)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_255",
    "data-name": "Line 255",
    y1: 1.202,
    transform: "translate(14.924 53.448)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_939",
    "data-name": "Rectangle 939",
    width: 1.628,
    height: 3.682,
    transform: "translate(18.055 51.615)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_940",
    "data-name": "Rectangle 940",
    width: 0.515,
    height: 3.682,
    transform: "translate(20.281 51.615)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_941",
    "data-name": "Rectangle 941",
    width: 27.49,
    height: 3.953,
    transform: "translate(2.642 47.51)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_256",
    "data-name": "Line 256",
    y2: 2.804,
    transform: "translate(4.155 47.583)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_257",
    "data-name": "Line 257",
    y1: 3.101,
    transform: "translate(5.654 48.184)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_258",
    "data-name": "Line 258",
    y2: 3.405,
    transform: "translate(7.556 47.583)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_259",
    "data-name": "Line 259",
    y2: 2.5,
    transform: "translate(9.66 47.484)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_260",
    "data-name": "Line 260",
    y2: 3.504,
    transform: "translate(11.562 47.682)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_261",
    "data-name": "Line 261",
    y1: 2.1,
    transform: "translate(13.461 49.185)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_262",
    "data-name": "Line 262",
    y2: 2.005,
    transform: "translate(15.165 47.682)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_263",
    "data-name": "Line 263",
    y1: 1.202,
    transform: "translate(17.566 49.485)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_942",
    "data-name": "Rectangle 942",
    width: 1.628,
    height: 3.682,
    transform: "translate(20.697 47.652)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_943",
    "data-name": "Rectangle 943",
    width: 0.515,
    height: 3.682,
    transform: "translate(22.923 47.652)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_944",
    "data-name": "Rectangle 944",
    width: 27.49,
    height: 3.953,
    transform: "translate(1.651 43.547)",
    fill: "#fff",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_264",
    "data-name": "Line 264",
    y2: 2.804,
    transform: "translate(3.164 43.62)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_265",
    "data-name": "Line 265",
    y1: 3.101,
    transform: "translate(4.663 44.221)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_266",
    "data-name": "Line 266",
    y2: 3.405,
    transform: "translate(6.565 43.62)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_267",
    "data-name": "Line 267",
    y2: 2.5,
    transform: "translate(8.669 43.521)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_268",
    "data-name": "Line 268",
    y2: 3.504,
    transform: "translate(10.571 43.719)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_269",
    "data-name": "Line 269",
    y1: 2.1,
    transform: "translate(12.47 45.222)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_270",
    "data-name": "Line 270",
    y2: 2.005,
    transform: "translate(14.175 43.719)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_271",
    "data-name": "Line 271",
    y1: 1.202,
    transform: "translate(16.575 45.522)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_945",
    "data-name": "Rectangle 945",
    width: 1.628,
    height: 3.682,
    transform: "translate(19.706 43.689)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_946",
    "data-name": "Rectangle 946",
    width: 0.515,
    height: 3.682,
    transform: "translate(21.932 43.689)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Currency--inject-21",
    transform: "translate(1.742 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 13.732,
    cy: 13.732,
    rx: 13.732,
    ry: 13.732,
    transform: "translate(101.748 121.479) rotate(-13.05)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 13.732,
    cy: 13.732,
    r: 13.732,
    transform: "translate(97.185 131.768) rotate(-45)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 11.04,
    cy: 11.04,
    r: 11.04,
    transform: "translate(100.991 131.768) rotate(-45)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3976",
    "data-name": "Path 3976",
    d: "M339.708,396.487a11.04,11.04,0,0,1,10.568-11.027H349.8a11.04,11.04,0,1,0,0,22.081h.476A11.034,11.034,0,0,1,339.708,396.487Z",
    transform: "translate(-233.188 -264.718)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_272",
    "data-name": "Line 272",
    x1: 1.047,
    transform: "translate(125.793 121.178)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_273",
    "data-name": "Line 273",
    x1: 0.763,
    transform: "translate(127.411 122.419)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_274",
    "data-name": "Line 274",
    x1: 0.859,
    transform: "translate(129.033 124.325)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_275",
    "data-name": "Line 275",
    x1: 1.146,
    transform: "translate(129.7 126.709)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_276",
    "data-name": "Line 276",
    x1: 1.05,
    transform: "translate(130.655 129.285)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_277",
    "data-name": "Line 277",
    x1: 1.146,
    transform: "translate(130.559 134.718)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_278",
    "data-name": "Line 278",
    x2: 0.951,
    transform: "translate(127.223 141.204)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_279",
    "data-name": "Line 279",
    x2: 1.047,
    transform: "translate(125.602 142.443)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_280",
    "data-name": "Line 280",
    x2: 1.05,
    transform: "translate(123.884 143.777)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_281",
    "data-name": "Line 281",
    x1: 1.622,
    transform: "translate(123.409 120.447)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3977",
    "data-name": "Path 3977",
    d: "M371.66,397h-7.12v1.982h.6c.773,0,1.11.436,1.11,1.427v.165H364.54v1.38h1.7c-.053.971-.528,1.3-1.3,1.3h-.406v1.982h.307c.991,0,1.427.476,1.427,1.764v2.176a4.268,4.268,0,0,0,.2,1.7h2.216a4.086,4.086,0,0,1-.238-1.684v-2.137c0-1.446-.357-2.493-1.443-2.949a2.486,2.486,0,0,0,1.38-2.15h3.273V400.59h-3.23v-.383a4.038,4.038,0,0,0-.36-1.82h3.59Z",
    transform: "translate(-250.454 -272.447)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 13.732,
    cy: 13.732,
    r: 13.732,
    transform: "translate(121.44 84.028)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 13.732,
    cy: 13.732,
    r: 13.732,
    transform: "translate(119.826 84.028)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 11.04,
    cy: 11.04,
    r: 11.04,
    transform: "translate(122.517 86.741)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3978",
    "data-name": "Path 3978",
    d: "M391.078,290.637a11.04,11.04,0,0,1,10.568-11.027h-.476a11.04,11.04,0,1,0,0,22.079c.159,0,.317,0,.476,0A11.04,11.04,0,0,1,391.078,290.637Z",
    transform: "translate(-267.593 -192.852)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_282",
    "data-name": "Line 282",
    x1: 1.05,
    transform: "translate(142.742 87.471)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_283",
    "data-name": "Line 283",
    x1: 0.763,
    transform: "translate(144.363 88.685)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_284",
    "data-name": "Line 284",
    x1: 0.859,
    transform: "translate(145.985 90.554)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_285",
    "data-name": "Line 285",
    x1: 1.143,
    transform: "translate(146.652 92.893)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_286",
    "data-name": "Line 286",
    x1: 1.047,
    transform: "translate(147.607 95.419)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_287",
    "data-name": "Line 287",
    x1: 1.143,
    transform: "translate(147.511 100.747)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_288",
    "data-name": "Line 288",
    x2: 0.954,
    transform: "translate(144.172 107.109)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_289",
    "data-name": "Line 289",
    x2: 1.05,
    transform: "translate(142.55 108.323)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_290",
    "data-name": "Line 290",
    x2: 1.047,
    transform: "translate(140.836 109.632)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_291",
    "data-name": "Line 291",
    x1: 1.622,
    transform: "translate(140.357 86.159)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3979",
    "data-name": "Path 3979",
    d: "M418.137,301.114v-1.463h-1.06l.661-5.961h-1.8l-.614,5.961h-.9l-.591-5.961h-1.982l-.575,5.961h-.908l-.637-5.961h-2l.66,5.961H407.1v1.463h1.45l.175,1.572H407.1v1.463h1.787l.3,2.675h2.834l.284-2.675h.928l.287,2.675h2.741l.3-2.675h1.562v-1.463h-1.4l.178-1.572Zm-7.6,0h.594l-.152,1.572H410.7Zm1.939,1.572.168-1.572h.277l.168,1.572Zm2.536,0h-.287l-.155-1.572h.6Z",
    transform: "translate(-278.959 -202.254)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 13.732,
    cy: 13.732,
    r: 13.732,
    transform: "translate(113.982 62.463) rotate(-45)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 13.732,
    cy: 13.732,
    rx: 13.732,
    ry: 13.732,
    transform: "translate(115.225 52.301) rotate(-13.53)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 11.04,
    cy: 11.04,
    rx: 11.04,
    ry: 11.04,
    transform: "translate(118.48 54.261) rotate(-13.48)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3980",
    "data-name": "Path 3980",
    d: "M385.668,181.087a11.04,11.04,0,0,1,10.568-11.027h-.476a11.04,11.04,0,0,0,0,22.081h.476A11.037,11.037,0,0,1,385.668,181.087Z",
    transform: "translate(-263.97 -118.669)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_292",
    "data-name": "Line 292",
    x1: 1.05,
    transform: "translate(140.972 51.988)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_293",
    "data-name": "Line 293",
    x1: 0.763,
    transform: "translate(142.593 53.206)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_294",
    "data-name": "Line 294",
    x1: 0.855,
    transform: "translate(144.215 55.074)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_295",
    "data-name": "Line 295",
    x1: 1.143,
    transform: "translate(144.882 57.413)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_296",
    "data-name": "Line 296",
    x1: 1.05,
    transform: "translate(145.833 59.939)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_297",
    "data-name": "Line 297",
    x1: 1.143,
    transform: "translate(145.741 65.268)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_298",
    "data-name": "Line 298",
    x2: 0.954,
    transform: "translate(142.402 71.629)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_299",
    "data-name": "Line 299",
    x2: 1.05,
    transform: "translate(140.78 72.843)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_300",
    "data-name": "Line 300",
    x2: 1.05,
    transform: "translate(139.063 74.152)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_301",
    "data-name": "Line 301",
    x1: 1.622,
    transform: "translate(138.587 50.679)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3981",
    "data-name": "Path 3981",
    d: "M411.926,183.47H408.72v6.536H406.9v1.856h1.82v1.856h-1.747v1.41h1.747v2.2H410.9v-2.2h1.691v-1.41H410.9v-1.6h1.027c2.18,0,3.246-1.209,3.246-3.425v-1.8C415.189,184.675,414.106,183.47,411.926,183.47Zm1.07,5.363c0,.991-.376,1.321-1.07,1.321H410.9v-4.706h1.027c.693,0,1.07.33,1.07,1.321Z",
    transform: "translate(-278.825 -127.675)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 13.732,
    cy: 13.732,
    r: 13.732,
    transform: "translate(107.028 13.78)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 13.732,
    cy: 13.732,
    r: 13.732,
    transform: "translate(105.413 13.78)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 11.04,
    cy: 11.04,
    rx: 11.04,
    ry: 11.04,
    transform: "matrix(0.979, -0.204, 0.204, 0.979, 106.086, 18.948)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3982",
    "data-name": "Path 3982",
    d: "M347.388,71.817A11.037,11.037,0,0,1,357.956,60.79h-.476a11.04,11.04,0,0,0,0,22.081h.476A11.037,11.037,0,0,1,347.388,71.817Z",
    transform: "translate(-238.332 -44.305)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_302",
    "data-name": "Line 302",
    x1: 1.05,
    transform: "translate(128.33 16.921)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_303",
    "data-name": "Line 303",
    x1: 0.763,
    transform: "translate(129.951 18.16)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_304",
    "data-name": "Line 304",
    x1: 0.859,
    transform: "translate(131.573 20.068)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_305",
    "data-name": "Line 305",
    x1: 1.143,
    transform: "translate(132.24 22.453)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_306",
    "data-name": "Line 306",
    x1: 1.05,
    transform: "translate(133.191 25.026)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_307",
    "data-name": "Line 307",
    x1: 1.143,
    transform: "translate(133.098 30.462)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_308",
    "data-name": "Line 308",
    x2: 0.954,
    transform: "translate(129.76 36.233)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_309",
    "data-name": "Line 309",
    x2: 1.05,
    transform: "translate(128.138 37.451)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_310",
    "data-name": "Line 310",
    x2: 1.047,
    transform: "translate(126.424 38.76)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_311",
    "data-name": "Line 311",
    x1: 1.622,
    transform: "translate(125.945 15.587)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3983",
    "data-name": "Path 3983",
    d: "M376.162,76.072V74.09H370.4v9.885H368.84V85.3H370.4v2.652h2.176V85.3h1.767V83.975h-1.767V82.227h2.81V80.246h-2.81V76.072Z",
    transform: "translate(-253.334 -53.212)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 13.732,
    cy: 13.732,
    rx: 13.732,
    ry: 13.732,
    transform: "translate(64.016 9.136) rotate(-13.05)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 13.732,
    cy: 13.732,
    r: 13.732,
    transform: "translate(59.459 19.42) rotate(-45)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 11.04,
    cy: 11.04,
    r: 11.04,
    transform: "translate(63.266 19.42) rotate(-45)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3984",
    "data-name": "Path 3984",
    d: "M225.468,47.31A11.04,11.04,0,0,1,236.036,36.28h-.476a11.04,11.04,0,1,0,0,22.079c.159,0,.317,0,.476,0A11.04,11.04,0,0,1,225.468,47.31Z",
    transform: "translate(-156.676 -27.889)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_312",
    "data-name": "Line 312",
    x1: 1.05,
    transform: "translate(88.062 8.83)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_313",
    "data-name": "Line 313",
    x1: 0.763,
    transform: "translate(89.683 10.068)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_314",
    "data-name": "Line 314",
    x1: 0.859,
    transform: "translate(91.305 11.977)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_315",
    "data-name": "Line 315",
    x1: 1.146,
    transform: "translate(91.972 14.358)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_316",
    "data-name": "Line 316",
    x1: 1.05,
    transform: "translate(92.926 16.934)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_317",
    "data-name": "Line 317",
    x1: 1.146,
    transform: "translate(92.831 22.37)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_318",
    "data-name": "Line 318",
    x2: 0.951,
    transform: "translate(89.495 28.853)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_319",
    "data-name": "Line 319",
    x2: 1.047,
    transform: "translate(87.873 30.092)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_320",
    "data-name": "Line 320",
    x2: 1.05,
    transform: "translate(86.156 30.824)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_321",
    "data-name": "Line 321",
    x1: 1.618,
    transform: "translate(85.681 7.496)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3985",
    "data-name": "Path 3985",
    d: "M252.809,52.435V51.424c0-2.216-1.05-3.484-3.187-3.484s-3.187,1.268-3.187,3.484v1.922h-.555v1.087h.555v1.09h-.555v1.09h.555V58.63c0,2.216,1.05,3.484,3.187,3.484s3.187-1.268,3.187-3.484V57.537h-2.058v1.248c0,.991-.376,1.344-1.07,1.344s-1.07-.353-1.07-1.344V56.612h3.048v-1.09h-3.048v-1.09h3.048V53.346h-3.048V51.285c0-.991.376-1.364,1.07-1.364s1.07.376,1.07,1.364v1.149Z",
    transform: "translate(-170.982 -35.699)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 13.732,
    cy: 13.732,
    r: 13.732,
    transform: "translate(26.202 13.78)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 13.732,
    cy: 13.732,
    r: 13.732,
    transform: "translate(24.587 13.78)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 11.04,
    cy: 11.04,
    rx: 11.04,
    ry: 11.04,
    transform: "matrix(0.974, -0.226, 0.226, 0.974, 25.065, 19.26)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3986",
    "data-name": "Path 3986",
    d: "M102.658,71.817A11.034,11.034,0,0,1,113.226,60.79h-.476a11.04,11.04,0,1,0,0,22.081h.476A11.034,11.034,0,0,1,102.658,71.817Z",
    transform: "translate(-74.425 -44.305)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_322",
    "data-name": "Line 322",
    x1: 1.047,
    transform: "translate(47.506 16.921)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_323",
    "data-name": "Line 323",
    x1: 0.763,
    transform: "translate(49.125 18.16)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_324",
    "data-name": "Line 324",
    x1: 0.859,
    transform: "translate(50.746 20.068)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_325",
    "data-name": "Line 325",
    x1: 1.146,
    transform: "translate(51.413 22.453)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_326",
    "data-name": "Line 326",
    x1: 1.05,
    transform: "translate(52.368 25.026)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_327",
    "data-name": "Line 327",
    x1: 1.146,
    transform: "translate(52.272 30.462)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_328",
    "data-name": "Line 328",
    x2: 0.951,
    transform: "translate(48.936 36.233)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_329",
    "data-name": "Line 329",
    x2: 1.047,
    transform: "translate(47.315 37.451)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_330",
    "data-name": "Line 330",
    x2: 1.05,
    transform: "translate(45.598 38.76)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_331",
    "data-name": "Line 331",
    x1: 1.622,
    transform: "translate(45.122 15.587)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3987",
    "data-name": "Path 3987",
    d: "M132.015,75.908V74.544c0-2.219-1.087-3.484-3.207-3.484s-3.2,1.265-3.2,3.484c0,2.414.931,3.322,1.407,4.69H125.7v1.681H127.3c-.04,1.427-.852,2.259-1.882,2.259v1.9h6.466V83.091h-3.752a3.028,3.028,0,0,0,1.11-2.18H131.5V79.234h-2.394c-.376-1.5-1.321-2.355-1.321-4.828,0-.991.393-1.367,1.087-1.367s1.09.376,1.09,1.367v1.5Z",
    transform: "translate(-90.305 -51.183)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 13.732,
    cy: 13.732,
    r: 13.732,
    transform: "translate(0 62.462) rotate(-45)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 13.732,
    cy: 13.732,
    rx: 13.732,
    ry: 13.732,
    transform: "translate(1.257 52.284) rotate(-13.45)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 11.04,
    cy: 11.04,
    rx: 11.04,
    ry: 11.04,
    transform: "translate(4.505 54.257) rotate(-13.44)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3988",
    "data-name": "Path 3988",
    d: "M40.538,181.087A11.04,11.04,0,0,1,51.106,170.06H50.63a11.04,11.04,0,1,0,0,22.081h.476A11.037,11.037,0,0,1,40.538,181.087Z",
    transform: "translate(-32.82 -118.669)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_332",
    "data-name": "Line 332",
    x1: 1.05,
    transform: "translate(26.991 51.988)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_333",
    "data-name": "Line 333",
    x1: 0.763,
    transform: "translate(28.613 53.206)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_334",
    "data-name": "Line 334",
    x1: 0.859,
    transform: "translate(30.234 55.074)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_335",
    "data-name": "Line 335",
    x1: 1.143,
    transform: "translate(30.901 57.413)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_336",
    "data-name": "Line 336",
    x1: 1.047,
    transform: "translate(31.856 59.939)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_337",
    "data-name": "Line 337",
    x1: 1.143,
    transform: "translate(31.76 65.268)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_338",
    "data-name": "Line 338",
    x2: 0.954,
    transform: "translate(28.421 71.629)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_339",
    "data-name": "Line 339",
    x2: 1.05,
    transform: "translate(26.799 72.843)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_340",
    "data-name": "Line 340",
    x2: 1.047,
    transform: "translate(25.085 74.152)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_341",
    "data-name": "Line 341",
    x1: 1.622,
    transform: "translate(24.607 50.679)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3989",
    "data-name": "Path 3989",
    d: "M66.766,183.393c0-.991.4-1.364,1.087-1.364s1.09.376,1.09,1.364v.575H71v-.436c0-1.879-.789-3.068-2.335-3.385V179.12h-1.78v1.027c-1.526.33-2.312,1.526-2.312,3.385,0,3.963,4.257,4.1,4.257,6.935,0,.991-.436,1.347-1.129,1.347s-1.126-.357-1.126-1.347v-1.09H64.53v.951c0,1.882.789,3.088,2.355,3.4v1.011h1.78v-1.011c1.546-.33,2.355-1.522,2.355-3.4C71.019,186.382,66.766,186.244,66.766,183.393Z",
    transform: "translate(-49.524 -124.746)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 13.732,
    cy: 13.732,
    r: 13.732,
    transform: "translate(3.989 84.028)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 13.732,
    cy: 13.732,
    r: 13.732,
    transform: "translate(2.374 84.028)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 11.04,
    cy: 11.04,
    r: 11.04,
    transform: "translate(5.065 86.741)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3990",
    "data-name": "Path 3990",
    d: "M35.388,290.637A11.044,11.044,0,0,1,45.956,279.61H45.48a11.04,11.04,0,1,0,0,22.079c.159,0,.317,0,.476,0A11.044,11.044,0,0,1,35.388,290.637Z",
    transform: "translate(-29.371 -192.852)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_342",
    "data-name": "Line 342",
    x1: 1.05,
    transform: "translate(25.29 87.471)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_343",
    "data-name": "Line 343",
    x1: 0.763,
    transform: "translate(26.912 88.685)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_344",
    "data-name": "Line 344",
    x1: 0.859,
    transform: "translate(28.533 90.554)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_345",
    "data-name": "Line 345",
    x1: 1.143,
    transform: "translate(29.2 92.893)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_346",
    "data-name": "Line 346",
    x1: 1.05,
    transform: "translate(30.152 95.419)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_347",
    "data-name": "Line 347",
    x1: 1.143,
    transform: "translate(30.059 100.747)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_348",
    "data-name": "Line 348",
    x2: 0.954,
    transform: "translate(26.72 107.109)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_349",
    "data-name": "Line 349",
    x2: 1.05,
    transform: "translate(25.099 108.323)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_350",
    "data-name": "Line 350",
    x2: 1.047,
    transform: "translate(23.385 109.632)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_351",
    "data-name": "Line 351",
    x1: 1.622,
    transform: "translate(22.906 86.159)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3991",
    "data-name": "Path 3991",
    d: "M65.316,293.933c.971-.456,1.407-1.367,1.407-2.791v-.5c0-1.721-.631-2.734-2.051-3.065V285.27H63.559v2.19h-.875v-2.186H61.571v2.186H60.21V301.33h1.361V303.3h1.113V301.33h.875V303.3h1.113v-2.071c1.5-.33,2.269-1.414,2.269-3.177v-1.129C66.941,295.435,66.485,294.388,65.316,293.933Zm-2.929-4.495h1.057c.773,0,1.106.436,1.106,1.427v.773c0,1.106-.492,1.463-1.321,1.463h-.842Zm2.378,8.534c0,1.027-.393,1.364-1.126,1.364H62.386v-4.247h.971c.991,0,1.4.4,1.4,1.684Z",
    transform: "translate(-46.631 -196.625)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 13.732,
    cy: 13.732,
    r: 13.732,
    transform: "translate(16.364 131.769) rotate(-45)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 13.732,
    cy: 13.732,
    rx: 13.732,
    ry: 13.732,
    transform: "translate(18.444 120.369) rotate(-9.04)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 11.04,
    cy: 11.04,
    rx: 11.04,
    ry: 11.04,
    transform: "translate(19.587 137.361) rotate(-65.97)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3992",
    "data-name": "Path 3992",
    d: "M90.078,396.487a11.044,11.044,0,0,1,10.568-11.027h-.476a11.04,11.04,0,0,0,0,22.081h.476A11.037,11.037,0,0,1,90.078,396.487Z",
    transform: "translate(-66 -264.718)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_352",
    "data-name": "Line 352",
    x1: 1.05,
    transform: "translate(43.355 121.178)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_353",
    "data-name": "Line 353",
    x1: 0.763,
    transform: "translate(44.977 122.419)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_354",
    "data-name": "Line 354",
    x1: 0.855,
    transform: "translate(46.598 124.325)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_355",
    "data-name": "Line 355",
    x1: 1.143,
    transform: "translate(47.265 126.709)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_356",
    "data-name": "Line 356",
    x1: 1.05,
    transform: "translate(48.216 129.285)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_357",
    "data-name": "Line 357",
    x1: 1.143,
    transform: "translate(48.124 134.718)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_358",
    "data-name": "Line 358",
    x2: 0.954,
    transform: "translate(44.785 141.204)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_359",
    "data-name": "Line 359",
    x2: 1.05,
    transform: "translate(43.164 142.443)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_360",
    "data-name": "Line 360",
    x2: 1.047,
    transform: "translate(41.45 143.777)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_361",
    "data-name": "Line 361",
    x1: 1.622,
    transform: "translate(40.971 120.447)",
    fill: "none",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3993",
    "data-name": "Path 3993",
    d: "M119.683,399.22l-2.533,8.491H118.8V408.8H117v.892h1.8v1.09H117v2.3h-2.18v-2.3h-1.8v-1.09h1.8V408.8h-1.8v-1.087h1.622l-2.513-8.491H114.4l1.6,6.113,1.6-6.113Z",
    transform: "translate(-81.404 -273.934)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-21",
    transform: "translate(51.596 37.193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3994",
    "data-name": "Path 3994",
    d: "M261.411,450.641l2.771,2.972s3.587,1.883,3.762,2,0,1.764,0,1.764H255.569a.433.433,0,0,1-.429-.443l.106-3.263S259.816,449.914,261.411,450.641Z",
    transform: "translate(-227.039 -345.504)",
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3995",
    "data-name": "Path 3995",
    d: "M268.023,467.46H255.166l-.026.793a.432.432,0,0,0,.429.443h12.375S268.02,467.969,268.023,467.46Z",
    transform: "translate(-227.039 -356.831)",
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3996",
    "data-name": "Path 3996",
    d: "M201.307,453.54a8.964,8.964,0,0,1,0,1.833c-.119.528-1.823,1.7-1.942,2.411a6.535,6.535,0,0,0-.056,1.41H208.3a6.487,6.487,0,0,0,.294-2.351c-.116-1.116-.37-3.3-.37-3.3Z",
    transform: "translate(-189.636 -347.508)",
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3997",
    "data-name": "Path 3997",
    d: "M208.569,467.82h-9.214a6.441,6.441,0,0,0,0,.938h8.993A6.856,6.856,0,0,0,208.569,467.82Z",
    transform: "translate(-189.666 -357.072)",
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3998",
    "data-name": "Path 3998",
    d: "M207.015,284.357l-.842,11.773v38.858l-.783,1.453v3.577h6.935s.561-3.131.561-3.577-.225-1.12-.225-1.565,4.581-37.639,4.581-37.639l.9-.225,2.906,40.311-.661.892,1.565,4.363,5.145-3.243,1.007-.225v-2.9a11,11,0,0,1-.33-2.573c0-1.341.112-35.724.112-35.724l-.112-13.871Z",
    transform: "translate(-193.719 -233.986)",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3999",
    "data-name": "Path 3999",
    d: "M263.06,210.247l3.963,9.495.991,6.605,1.9,1.569s3.633-7.761,3.715-8.587-6.192-15.77-6.523-16.843S265.289,201,265.289,201H263.72",
    transform: "translate(-232.343 -178.37)",
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4000",
    "data-name": "Path 4000",
    d: "M275.56,250.475s.991-2.725,3.22-2.725",
    transform: "translate(-240.715 -209.681)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4001",
    "data-name": "Path 4001",
    d: "M277.31,272.038s1.816-1.9,2.972,1.073",
    transform: "translate(-241.887 -225.548)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4002",
    "data-name": "Path 4002",
    d: "M274.232,276.882s-1.073-1.569-1.651-1.651a2.038,2.038,0,0,0-1.238.413l-1.321,1.073s-1.4,1.9-1.238,2.312A23.532,23.532,0,0,0,270.1,282.5c.248.083,1.486-.908,1.486-.908s1.816-1.569,1.982-2.477A16.512,16.512,0,0,1,274.232,276.882Z",
    transform: "translate(-236.167 -228.08)",
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4003",
    "data-name": "Path 4003",
    d: "M220.744,195.4l.5,18.494s.991,2.89.661,3.8a2.741,2.741,0,0,1-.991,1.321s-17.586.33-18.659.248a2.368,2.368,0,0,1-1.651-.908L195.81,191.52l10.155-5.036a34.348,34.348,0,0,1,4.954-.991c1.982-.165,10.073,5.7,10.073,5.7l.165.66",
    transform: "translate(-187.303 -167.982)",
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4004",
    "data-name": "Path 4004",
    d: "M239.31,198.722l2.394,2.229-1.734,17.834,2.477,5.036,2.89-5.532L242.7,201.2l1.9-3.385-2.972-2.064Z",
    transform: "translate(-216.437 -174.854)",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4005",
    "data-name": "Path 4005",
    d: "M227.447,178.135l-1.816,1.156-1.321,3.055,3.468,7.1,2.559-3.55,1.853.938,1.532-1.02,3.055,2.642s-1.982-5.945-2.559-7.513a5.363,5.363,0,0,0-2.312-2.642A9.783,9.783,0,0,0,227.447,178.135Z",
    transform: "translate(-206.391 -162.936)",
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4006",
    "data-name": "Path 4006",
    d: "M232.434,134.449a12.292,12.292,0,0,1,2.348,2.19c.568.892.485,1.942.812,2.269s2.186.809,2.186,1.539-1.377,1.945-1.377,1.945.244,3.808-.083,4.373-3.563.73-3.563.73-.33,4.458-.33,5.753a7.737,7.737,0,0,1-1.215,3.161l-2.424-2.259a37.033,37.033,0,0,1-2.675-4.376c-.324-.974.1-4.541.1-4.541s-3.808-3.963-3.3-7.371,5.832-3.633,5.994-3.963-.809-.888.33-1.295S233,133.479,232.434,134.449Z",
    transform: "translate(-205.42 -132.51)",
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4007",
    "data-name": "Path 4007",
    d: "M229.088,132.555c-1.133.4-.162.971-.33,1.295s-5.509.568-5.994,3.963,3.352,7.388,3.352,7.388a1.518,1.518,0,0,1-.02.208l.509-.37a4.576,4.576,0,0,1-.892-2.348c.1-.971,1.215-1.215,1.456-.974s.489.892,1.215,1.053.406-.971.406-.971l-.661-2.028s2.269-1.78,2.186-2.348-1.228-1.3-1.228-1.3l3.243-1.7C232.906,133.447,230.234,132.149,229.088,132.555Z",
    transform: "translate(-205.327 -132.478)",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4008",
    "data-name": "Path 4008",
    d: "M254.4,147.826c.31.991.026,1.982-.637,2.193s-1.45-.443-1.764-1.446-.026-1.982.637-2.193S254.089,146.822,254.4,147.826Z",
    transform: "translate(-224.852 -141.762)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4009",
    "data-name": "Path 4009",
    d: "M259.41,145.72a2.082,2.082,0,0,1,1.255,1.45,3.765,3.765,0,0,1,.066.872",
    transform: "translate(-229.899 -141.347)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4010",
    "data-name": "Path 4010",
    d: "M256.635,151.563c.079.4.02.74-.135.773s-.33-.264-.419-.661-.02-.74.132-.769S256.555,151.17,256.635,151.563Z",
    transform: "translate(-227.642 -144.819)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_362",
    "data-name": "Line 362",
    x1: 5.324,
    y2: 2.421,
    transform: "translate(21.826 6.81)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_363",
    "data-name": "Line 363",
    y1: 0.492,
    x2: 1.136,
    transform: "translate(29.551 5.572)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4011",
    "data-name": "Path 4011",
    d: "M258.178,163.768a1.529,1.529,0,0,1-2.038-.608",
    transform: "translate(-227.709 -153.027)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4012",
    "data-name": "Path 4012",
    d: "M247.124,177.616l-2.814-.116,2.642,2.229Z",
    transform: "translate(-219.785 -162.631)",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4013",
    "data-name": "Path 4013",
    d: "M234.43,169.994l1.034.416.66-.66",
    transform: "translate(-213.168 -157.441)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4014",
    "data-name": "Path 4014",
    d: "M179.4,203.75l-8.091,18.329,4.046,2.807,7.844-10.212",
    transform: "translate(-170.894 -180.212)",
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4015",
    "data-name": "Path 4015",
    d: "M175.09,249.75l7.018,10.155-3.137,2.229s-8.834-7.6-8.917-8.339,1.486-3.22,1.486-3.22",
    transform: "translate(-170.051 -211.021)",
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_364",
    "data-name": "Line 364",
    y1: 2.477,
    x2: 3.137,
    transform: "translate(8.012 47.811)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4016",
    "data-name": "Path 4016",
    d: "M200.217,280.5s3.458,3.088,3.633,3.418a1.285,1.285,0,0,1,.083,1.238,1.175,1.175,0,0,1-.9.545s-.826,1.569-1.9,1.734-2.394-.33-2.559-.991l-.33-1.321-1.156-2.394Z",
    transform: "translate(-188.16 -231.615)",
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4017",
    "data-name": "Path 4017",
    d: "M200.56,294.5a8.111,8.111,0,0,0,1.651,1.4",
    transform: "translate(-190.484 -240.992)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-21",
    transform: "translate(2.372 149.058)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_365",
    "data-name": "Line 365",
    x2: 10.238,
    transform: "translate(143)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_366",
    "data-name": "Line 366",
    x2: 140.028,
    transform: "translate(0)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyBro);
export default __webpack_public_path__ + "static/media/Currency-bro.bf6f8d07d57bab9e294bcf8497c55abf.svg";
export { ForwardRef as ReactComponent };